import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { floatControlLabel } from '@project/shared/utils/form-control/js/form-control';
import { FavouritesAction } from '../../../molecules/favourites-action/js/favourites-action';
import * as copy from 'copy-to-clipboard';

const classes = {
	popupBox: "js-m-modal-actions",
	textareaContainer: "js-m-modal-actions-textarea-container",
	textareaBox: "js-m-modal-actions__textarea",
	textareaValLength: "js-m-modal-actions__textarea-count-length",
	textareaValLengthMax: "js-m-modal-actions__textarea-count-max",

	confirmationBtn: "js-m-modal-actions-confirmation",

	emailContainer: "js-m-modal-actions-email-container",
	emailAdd: "js-add-email-input",
	emailRemove: "js-remove-email-input",
	emailTemplate: "js-m-modal-actions__email-template",
	emailGroup: "js-m-modal-actions__email-group",
	emailRequired: "js-email-required",
	addEmailDisabled: 'state-m-modal-actions__add-email--disabled',

	clipboardTitle: "js-m-modal-actions__clipboard-anchor",

	inputValidationError: "input-validation-error",
	inputAvailableError: "input-available-error",
	fieldValidationError: "js-checklist-validation-error",
}

@createModule('FavouritesShare')
/**
 * favourites-prompt
 *
 */
export class FavouritesShare extends TerrificSpec {
	$ctx: JQuery;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		resolve();
	}

	generateEmailTemplate(emailTemplateHtml: string) {

		const $template = $(emailTemplateHtml);
		// get a random id
		const date = new Date();
		const id = `emailtemp_${date.getSeconds()}${date.getMilliseconds()}`;

		$template.find("label").attr("for", id);
		$template.find("input").attr("id", id);

		return $template.prop("outerHTML");
	}

	rebindEmailViewEvents($popup: JQuery) {

		// bind Email events
		const $emailContainer = $popup.find(`.${classes.emailContainer}`);
		if ($emailContainer.length > 0) {
			this.bindEmailContainerEvents($emailContainer);
		}

		const $emailMessageContainer = $popup.find(`.${classes.textareaContainer}`);
		if ($emailMessageContainer.length > 0) {
			this.bindEmailMessageEvents($emailMessageContainer);
		}

	}

	bindEmailSubmitEvent($popup: JQuery, contentType: string) {
		// bind submit button
		$popup.find(`.${classes.confirmationBtn}`).on('click', (ev: any) => {
			const url = $popup.data("api-endpoint");
			const id = $popup.data("item-id");

			const textareaTxt = $popup.find("textarea").val();
			const textbox = this.getEmailAddresses($popup);

			if (this.canSubmit($popup)) {

				const $btnEle = $(ev.currentTarget);
				$btnEle.attr("disabled", "disabled");

				new FavouritesAction().track("E-Mail", contentType);

				$.ajax({
					type: 'post',
					url: url,
					dataType: 'json',
					data:
					{
						publicId: id,
						textareaInput: textareaTxt,
						textInput: textbox
					},
					success: (response: any) => {

						if (response.success) {
							const url = this.getReloadUrl(response.id);
							window.location.replace(url);
						}
						else {
							if (response.isUnavailable) {
								$popup.find(`.${classes.textareaContainer}`).find("textarea").addClass(classes.inputValidationError);;
							} else {
								const url = this.getReloadUrl("0");
								window.location.replace(url);
								console.log(response.message);
							}

						}
					},
					complete: () => {
						$btnEle.removeAttr("disabled");
					},
					error: (xhr: any, status: string, error: string) => {
						console.log(`submit action-view error, endpoint: ${url}, ${xhr.status}, ${xhr.statusText}, ${error}`);
					}
				});
			}
		});
	}

	bindClipboardEvents($popup: JQuery, contentType: string) {

		const $clipboardTitle = $popup.find(`.${classes.clipboardTitle}`);
		$clipboardTitle.on("click", (ev: any) => {

			new FavouritesAction().track("Copy Link", contentType);

			const opts = {
				debug: false,
				message: 'Press #{⌘+C} on macOS or #{Ctrl+C} on Windows to copy',
			};

			let snapshot = "";
			let data = $popup.find("script[type='application/json']");
			if (data.length > 0) {
				let json = data[0].innerHTML;
				if (json.length > 0) {

					let jsonData = JSON.parse(json);
					snapshot = jsonData.Snapshot;

				}
			}

			copy(snapshot, opts);

			$clipboardTitle.prev().removeClass('show');
			$clipboardTitle.prev().addClass('show');
			window.setTimeout(() => {
				$clipboardTitle.prev().removeClass('show');
			}, 3500);

		});

	}

	bindEmailContainerEvents($emailContainer: JQuery) {

		const _this = this;

		// bind email-box floating label
		$emailContainer.find(".a-input").on("focus", (ev: any) => {
			const me = ev.currentTarget;
			floatControlLabel(me, true)
		});

		// bind email box event
		$emailContainer.find("input[type=email]").first().on("input propertychange", function (ev: any) {
			const $target = $(ev.currentTarget);
			_this.validateEmailBox($target);
		});

		// bind add-email event
		$emailContainer.find(`.${classes.emailAdd}`).on("click", (ev: any) => {
			const $emailTemplate = $emailContainer.find(`.${classes.emailTemplate}`);

			const $emailTemplateHtml = this.generateEmailTemplate($emailTemplate.html());

			const $addEmailBtn = $(ev.currentTarget);

			var emailLength = $emailContainer.find(`.${classes.emailGroup}`).length;
			if (emailLength > 9) {
				$addEmailBtn.addClass(classes.addEmailDisabled);
			}

			$emailTemplate.before($emailTemplateHtml);

			// bind float event to new created emailbox
			$emailTemplate.prev().find(".a-input").on("focus", (ev: any) => {
				const me = ev.currentTarget;
				floatControlLabel(me, true)
			});

			// bind remove emailbox event to new created emailbox
			$emailTemplate.prev().find(`.${classes.emailRemove}`).on("click", (ev: any) => {
				$(ev.currentTarget).parent().remove();
				$addEmailBtn.removeClass(classes.addEmailDisabled);
			});

			// bind emailvalidate event to new created emailbox
			$emailTemplate.find("input[type=email]").on("input propertychange", function (ev: any) {
				const $target = $(ev.currentTarget);
				_this.validateEmailBox($target);
			});
		});
	}

	bindEmailMessageEvents($textareaContainer: any) {

		const _this = this;
		const favorAction = new FavouritesAction();

		// bind text area floating label
		$textareaContainer.on("focus", `.${classes.textareaBox}`, (ev: any) => {
			const me = ev.currentTarget;
			floatControlLabel(me, true)

			// remove textarea malicious content validation message
			if ($(me).hasClass(classes.inputValidationError)) {
				$(me).removeClass(classes.inputValidationError);
			}
		});

		// bind text area counter
		$textareaContainer.find(`.${classes.textareaBox}`).on("input propertychange", function (ev: any) {
			const $target: any = $(ev.currentTarget);
			favorAction.countTextarea($target);
		})
	}

	getEmailAddresses($popup: JQuery): string {
		const $emailGroupEles = $popup.find(`.${classes.emailContainer}`).children(`.${classes.emailGroup}`).find("input[type='email']");
		const addressArr = new Array<string>();
		$emailGroupEles.each((i: any, e: any) => {
			const value = $(e).val() as string;
			if (typeof (value) != "undefined") {
				addressArr.push(value);
			}
		});
		const addressStr = addressArr.join(";");

		return addressStr;

	}

	// logic: 
	// 1. first email is required
	// 2. email addresses are available
	// 3. email message 
	canSubmit($popup: JQuery): boolean {
		// validate textbox
		let emailboxVal = true;

		const $emailContainer = $popup.find(`.${classes.emailContainer}`);
		if ($emailContainer.length > 0) {
			emailboxVal = this.ValidateEmailContainer($emailContainer);
		}

		return emailboxVal;
	}

	ValidateEmailAddress(email: string): boolean {
		if (email == null || email == undefined || email == '' || email.length == 0) {
			return true;
		}
		const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}

	ValidateEmailContainer($emailContainer: JQuery) {

		let result = true;

		const $emailGroupEles = $emailContainer.children(`.${classes.emailGroup}`);

		$emailGroupEles.each((i: number, e: any) => {

			const $emailInputBox = $(e).find("input[type=email]");

			const boxResult = this.validateEmailBox($emailInputBox);
			if (!boxResult) {
				result = false;
			}

		});

		return result;
	}

	validateEmailBox($emailBox: any): boolean {

		const email = $emailBox.val();

		let result = true;
		if ($emailBox.parents(`.${classes.emailGroup}`).hasClass(classes.emailRequired)) {

			if (email == null || email == undefined || email == '' || email.length == 0) {
				$emailBox.addClass(classes.inputValidationError);
				result = false;
			} else {
				$emailBox.removeClass(classes.inputValidationError);
			}
		}

		const emailVal = this.ValidateEmailAddress(email);

		if (emailVal) {
			$emailBox.removeClass(classes.inputAvailableError);
		} else {
			$emailBox.addClass(classes.inputAvailableError);
			result = false;
		}

		return result;
	}

	getReloadUrl(sharedListId: string): string {

		let result = window.location.href;

		let currentQuery = window.location.search.substr(1);

		let resultArr = new Array();
		const paramArr = currentQuery.split("&");

		paramArr.forEach((value: string, index: number, array: string[]) => {
			if (value.indexOf("sharedsuccess") < 0) {
				resultArr.push(value);
			}
		});
		resultArr.push(`sharedsuccess=${sharedListId}`);

		const query = resultArr.join("&");
		result = `${window.location.origin}${window.location.pathname}?${query}`;

		return result;
	}

	stop() { }
}
